export default __webpack_public_path__ + "f0aeb1c3c46823e99c095531e80f3210.svg";